import BrowserIcon from 'LuxKit/Icons/custom/BrowserIcon'

interface AirlineLogo {
  id: string
  alt: string
  width: number
}

const airlineLogos: Record<string, AirlineLogo> = {
  qantas:
    {
      id: 'carrier-qf_brkc30',
      alt: 'Qantas Logo',
      width: 100,
    },
  emirates: {
    id: 'carrier-ek_ig06eg',
    alt: 'Emirates Logo',
    width: 100,
  },
  etihad: {
    id: 'EYAIRWAYS_1019_CMYK-01_q0fjr0',
    alt: 'Etihad Airways Logo',
    width: 100,
  },
  thai: {
    id: 'carrier-tg_r1bpaf',
    alt: 'Thai Logo',
    width: 100,
  },
  indonasia: {
    id: 'carrier-ga_sxskqs',
    alt: 'Garuda Indonesia Logo',
    width: 100,
  },
  virgin: {
    id: 'carrier-va_ax3sgz',
    alt: 'Virgin Australia Logo',
    width: 100,
  },
  singapore: {
    id: 'carrier-sq_bqotar',
    alt: 'Singapore Airlines Logo',
    width: 100,
  },
  malaysia: {
    id: 'carrier-mh_ammdag',
    alt: 'Malaysia Airlines Logo',
    width: 100,
  },
  airnz: {
    id: '9ch84i3xz57lwu0z840u',
    alt: 'Air New Zealand Logo',
    width: 100,
  },
  japan: {
    id: 'carrier-jal_gfcrd9',
    alt: 'Japan Airlines Logo',
    width: 100,
  },
  americanAirlines: {
    id: 'y0j9vk7dxig1rrzjguuf',
    alt: 'American Airlines Logo',
    width: 100,
  },
  unitedAirlines: {
    id: 'vykucynxbclgsjaa949',
    alt: 'United Airlines Logo',
    width: 100,
  },
  delta: {
    id: 'zhufgg31ihna5l2z47l',
    alt: 'Delta Airlines Logo',
    width: 100,
  },
  alaskan: {
    id: 'xmih9cs6e1wyy30azip',
    alt: 'Alaskan Airlines Logo',
    width: 100,
  },
  airCanada: {
    id: '77c38x6brbnupv57jjct',
    alt: 'Air Canada Logo',
    width: 100,
  },
  westjet: {
    id: 'drht1poxvlg5in7r45ak',
    alt: 'Westjet Airlines Logo',
    width: 100,
  },
  jetBlue: {
    id: '2kv6a8ndyip7pqwuhqv',
    alt: 'JetBlue Airlines Logo',
    width: 100,
  },
  copa: {
    id: 'kkaehz57qlnyijqbozn',
    alt: 'Copa Airlines Logo',
    width: 100,
  },
  britishAirways: {
    id: 'us3d83jbrp137rt77dl',
    alt: 'British Airways Logo',
    width: 100,
  },
  qatar: {
    id: 'vun4q04779g9juj24z4l',
    alt: 'Qatar Airways Logo',
    width: 100,
  },
  ryanair: {
    id: 'rygurdhykjubb0axap63',
    alt: 'Ryanair Logo',
    width: 100,
  },
  virginAtlantic: {
    id: 'rmue2bbnal5y314pg1k',
    alt: 'Virgin Atlantic Logo',
    width: 100,
  },
  easyJet: {
    id: 'r1y2d49j6cmz3f2rubji',
    alt: 'EasyJet Logo',
    width: 100,
  },
  cathayPacific: {
    id: 'if0r6e2xrel6e0y9q7b',
    alt: 'Cathay Pacific',
    width: 100,
  },
  evaAir: {
    id: 'bvq181twm7xzdwlublrs',
    alt: 'EVA Air',
    width: 100,
  },
  hongKongExpress: {
    id: 'jq3yuptp9s05iwywk4x7',
    alt: 'Hong Kong Express Airways',
    width: 100,
  },
  indigo: {
    id: 's8rjj8hq2xbz107fz',
    alt: 'IndiGo Logo',
    width: 100,
  },
  spiceJet: {
    id: 'alpm0r9x6w7zqgs5gb',
    alt: 'Spice Jet Logo',
    width: 100,
  },
  airAsia: {
    id: '1aljbjddceizx9b4ceso',
    alt: 'Air Asia Logo',
    width: 100,
  },
  scoot: {
    id: 'pgsrdvxjgeqg8un578ar',
    alt: 'Scoot Logo',
    width: 100,
  },
  airIndiaExpress: {
    id: 'd8604lkqinwyff60ip4v',
    alt: 'Air India Express Logo',
    width: 100,
  },
  goFirst: {
    id: '12y5v6go3b7r1gwx2h9',
    alt: 'Go First Logo',
    width: 100,
  },
  vietJet: {
    id: 's6x92ypwqat2h5pqwkp',
    alt: 'VietJet Logo',
    width: 100,
  },
  airArabia: {
    id: 'r1oj3kg3v6f3ltm6j6t',
    alt: 'Air Arabia Logo',
    width: 100,
  },
}

interface RegionContent {
  text: Array<string>
  steps?: Array<{ title: string, text: string, image: string }>
  airlineLogos?: Array<AirlineLogo>
  slug?: string
}

export const FlightLandingPageRegionContent: Record<string, RegionContent> = {
  AU: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels, tours and flights to travel protection and experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    steps: [
      {
        title: 'Select ‘Check Availability’ for Holiday + Flights',
        text: 'Now when you browse Luxury Escapes packages you have the choice between a holiday only package and a holiday + flights option.',
        image: 'check-availability-v2_sqaead',
      },
      {
        title: 'Add your number of travellers and select your departure airport',
        text: 'Select your number of travellers the same way you do when booking a holiday package and select your departure airport from the dropdown list.',
        image: 'capacity-v2_zvfoho',
      },
      {
        title: 'Select your check-in date',
        text: 'Choose which month and year you want to travel in. You will be able to easily compare prices for the next 12-months to find the best time to travel.',
        image: 'check-in-v2_gkcvi7',
      },
      {
        title: 'Choose flights from your favourite airline',
        text: 'Browse the available flight times and prices within your chosen travel dates. Select your exact departure and return date.',
        image: 'available-flight-gds-v2_hjleqy',
      },
      {
        title: 'Review your booking before checking out',
        text: 'Take a moment to review your chosen holiday package and flight details before checking out securely through our website.',
        image: 'review-order-gds-v2_rkq1tg',
      },
    ],
    airlineLogos: [airlineLogos.qantas, airlineLogos.emirates, airlineLogos.etihad, airlineLogos.thai, airlineLogos.indonasia, airlineLogos.virgin, airlineLogos.singapore, airlineLogos.malaysia],
    slug: 'flights-faq',
  },
  GB: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels, tours and flights to travel protection and experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    airlineLogos: [airlineLogos.emirates, airlineLogos.qatar, airlineLogos.etihad, airlineLogos.singapore, airlineLogos.malaysia, airlineLogos.britishAirways, airlineLogos.cathayPacific, airlineLogos.easyJet],
  },
  NZ: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels, tours and flights to travel protection and experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    steps: [
      {
        title: 'Select ‘Check Availability’ for Holiday + Flights',
        text: 'Now when you browse Luxury Escapes packages you have the choice between a holiday only package and a holiday + flights option.',
        image: 'Image_1_NZ_phga5s',
      },
      {
        title: 'Add your number of travellers and select your departure airport',
        text: 'Select your number of travellers the same way you do when booking a holiday package and select your departure airport from the dropdown list.',
        image: 'Image_2_NZ_zicb3i',
      },
      {
        title: 'Select your check-in date',
        text: 'Choose which month and year you want to travel in. You will be able to easily compare prices for the next 12-months to find the best time to travel.',
        image: 'Image_3_NZ_vv0wft',
      },
      {
        title: 'Choose flights from your favourite airline',
        text: 'Browse the available flight times and prices within your chosen travel dates. Select your exact departure and return date.',
        image: 'Image_4_NZ_kf7dfc',
      },
      {
        title: 'Review your booking before checking out',
        text: 'Take a moment to review your chosen holiday package and flight details before checking out securely through our website.',
        image: 'Image_5_NZ_kb2e99',
      },
    ],
    airlineLogos: [airlineLogos.airnz, airlineLogos.emirates, airlineLogos.etihad, airlineLogos.thai, airlineLogos.indonasia, airlineLogos.virgin, airlineLogos.singapore, airlineLogos.malaysia],
  },
  SG: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels to tours and flights to experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    steps: [
      {
        title: 'Select ‘Check Availability’ for Holiday + Flights',
        text: 'Now when you browse Luxury Escapes packages you have the choice between a holiday only package and a holiday + flights option.',
        image: 'Image_1_SG_nxhgmn',
      },
      {
        title: 'Add your number of travellers and select your departure airport',
        text: 'Select your number of travellers the same way you do when booking a holiday package and select your departure airport from the dropdown list.',
        image: 'Image_2_SG_zej3yr',
      },
      {
        title: 'Select your check-in date',
        text: 'Choose which month and year you want to travel in. You will be able to easily compare prices for up to 12-months in advance to find the best time to travel.',
        image: 'Image_3_SG_qoyryp',
      },
      {
        title: 'Choose flights from your favourite airline',
        text: 'Browse the available flight times and prices within your chosen travel dates. Select your exact departure and return date.',
        image: 'Image_4_SG_rxi8sl',
      },
      {
        title: 'Review your booking before checking out',
        text: 'Take a moment to review your chosen holiday package and flight details before checking out securely through our website.',
        image: 'Image_5_SG_nqet62',
      },
    ],
    airlineLogos: [airlineLogos.singapore, airlineLogos.indonasia, airlineLogos.malaysia, airlineLogos.thai, airlineLogos.japan, airlineLogos.emirates, airlineLogos.etihad, airlineLogos.qantas],
  },
  HK: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels, tours and flights to travel protection and experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    steps: [
      {
        title: 'Select ‘Check Availability’ for Holiday + Flights',
        text: 'Now when you browse Luxury Escapes packages you have the choice between a holiday only package and a holiday + flights option.',
        image: 'hk-flights-1_bbgorh',
      },
      {
        title: 'Add your number of travellers and select your departure airport',
        text: 'Select your number of travellers the same way you do when booking a holiday package and select your departure airport from the dropdown list.',
        image: 'hk-flights-2_quooft',
      },
      {
        title: 'Select your check-in date',
        text: 'Choose which month and year you want to travel in. You will be able to easily compare prices for the next 12-months to find the best time to travel.',
        image: 'hk-flights-3_tfhy7m',
      },
      {
        title: 'Choose flights from your favourite airline',
        text: 'Browse the available flight times and prices within your chosen travel dates. Select your exact departure and return date.',
        image: 'hk-flights-4_q9e3ti',
      },
      {
        title: 'Review your booking before checking out',
        text: 'Take a moment to review your chosen holiday package and flight details before checking out securely through our website.',
        image: 'hk-flights-5_ti61lo',
      },
    ],
    airlineLogos: [airlineLogos.cathayPacific, airlineLogos.singapore, airlineLogos.emirates, airlineLogos.thai, airlineLogos.evaAir, airlineLogos.indonasia, airlineLogos.hongKongExpress, airlineLogos.qatar],
  },
  US: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels, tours and flights to travel protection and experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    steps: [
      {
        title: 'Select ‘Check Availability’ for Holiday + Flights',
        text: 'Now when you browse Luxury Escapes packages you have the choice between a holiday only package and a holiday + flights option.',
        image: 'check-availability-v2_sqaead',
      },
      {
        title: 'Add your number of travellers and select your departure airport',
        text: 'Select your number of travellers the same way you do when booking a holiday package and select your departure airport from the dropdown list.',
        image: 'capacity-v2_zvfoho',
      },
      {
        title: 'Select your check-in date',
        text: 'Choose which month and year you want to travel in. You will be able to easily compare prices for the next 12-months to find the best time to travel.',
        image: 'check-in-v2_gkcvi7',
      },
      {
        title: 'Choose flights from your favourite airline',
        text: 'Browse the available flight times and prices within your chosen travel dates. Select your exact departure and return date.',
        image: 'available-flight-gds-v2_hjleqy',
      },
      {
        title: 'Review your booking before checking out',
        text: 'Take a moment to review your chosen holiday package and flight details before checking out securely through our website.',
        image: 'review-order-gds-v2_rkq1tg',
      },
    ],
    airlineLogos: [airlineLogos.americanAirlines, airlineLogos.unitedAirlines, airlineLogos.delta, airlineLogos.alaskan, airlineLogos.airCanada, airlineLogos.westjet, airlineLogos.jetBlue, airlineLogos.copa],
    slug: 'us-flights-faq',
  },
  IN: {
    text: [
      'Luxury Escapes now provides your full holiday experience. From hotels, tours and flights to travel protection and experiences, the world’s best holidays have never been easier to book.',
      'Whether you are a loyal frequent flyer member, prefer a select airline or simply want the best value fare, we have you covered.',
    ],
    steps: [
      {
        title: 'Choose your package options and select ‘Book now’',
        text: 'When you browse Luxury Escapes packages you have the choice between a holiday-only package and a holiday+flights package. Simply choose your number of travellers, travel dates and departure airport.',
        image: 'aqyg3i3q7zk1pjotfds',
      },
      {
        title: 'Choose flights from your favourite airline',
        text: 'Browse the available flight times and prices within your chosen travel dates.',
        image: 'ikpsmasr0mfy8vyx0v6',
      },
      {
        title: 'Review your booking before finalising payment ',
        text: 'Take a moment to review your holiday+flights package details before checking out securely using our website.',
        image: '6y18jh9gbbliz1g88tsm',
      },
    ],
    airlineLogos: [airlineLogos.indigo, airlineLogos.spiceJet, airlineLogos.airAsia, airlineLogos.scoot, airlineLogos.airIndiaExpress, airlineLogos.goFirst, airlineLogos.vietJet, airlineLogos.airArabia],
    slug: 'in-flights-faq',
  },
}

const content = {
  header: {
    title: 'Flights Have Landed',
    subTitle: 'Book flights and escapes all in the one place',
  },
  mainContent: {
    title: 'Fly With The World’s Best Airlines',
  },
  howItWorks: {
    title: 'How It Works',
    subTitle: 'When booking your next Luxury Escape, you will now have access to all major airlines. The best part? You can view flights up to one year in advance, making it easy to compare the best prices and dates before you book.',
  },
  feedback: [
    {
      title: 'Give feedback online',
      cta: [{
        text: 'Start Survey Now',
        link: 'https://www.research.net/r/BZFNT6M',
      }],
      icon: <BrowserIcon width={55} height={46} colour="primary" />,
    },
  ],
}

export default content
